import { TableBody, TableCell, TableRow } from '@client/toolkit';
import React, { useMemo } from 'react';
import { ExpanableTableWraper } from '../../components/expanable-table-wraper';
import { useConsumptionByEnergyTypeQuery } from './consumption-graph';
import { useTagLabel } from '../../../../utils/eos/getTagLabel';
import { useChartResolutionDateFormat } from '../../../../components/charts/hooks/useChartLabelFormat';

function getPeriodeTableLabelByResolution(resolution?: string | null) {
  switch (resolution) {
    case 'hourly':
      return 'Time';
    case 'daily':
      return 'Dato';
    case 'weekly':
      return 'Uke';
    case 'monthly':
      return 'Måned';
    case 'yearly':
      return 'År';
    default:
      return 'Tidspunkt';
  }
}

export const ConsumptionTable: React.FC = () => {
  const getTagLabel = useTagLabel();
  const { data, tags, resolution } = useConsumptionByEnergyTypeQuery();
  const { getFormat } = useChartResolutionDateFormat(resolution);
  const { columns, rows } = useMemo(() => {
    const mappedColumns = tags.map((tag) => ({
      key: tag,
      label: tag === 'energy' ? 'Totalt (kWh)' : `${getTagLabel(tag)} (kWh)`,
    }));
    const preparedColumns = [{ key: 'periode', label: getPeriodeTableLabelByResolution(resolution) }, ...mappedColumns];
    const mappedRows = data.map((item) => ({
      id: item.key,
      columns: preparedColumns.map((column) => ({
        key: column.key,
        value: column.key === 'periode' ? getFormat(item.key) : item[column.key],
      })),
    }));
    return {
      columns: preparedColumns,
      rows: mappedRows,
    };
  }, [data, tags, resolution]);

  return (
    <>
      <ExpanableTableWraper
        columns={columns}
        data={rows}
        selectable={false}
        renderBody={(
          data,
          selectedRows,
          expandedRows,
          handleToggleSelect,
          handleKeyDownSelect,
          handleToggleExpand,
          handleKeyDownExpand,
        ) => (
          <TableBody>
            {data.map(({ id, columns }) => (
              <React.Fragment key={id}>
                <TableRow className="bg-surface-elevated/40 border-b border-surface-elevated group hover:bg-surface-elevated">
                  {columns.map((column) => (
                    <TableCell key={column.key} className="px-2 py-2 align-top">
                      {column.value ? column.value : '-'}
                    </TableCell>
                  ))}
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        )}
      />
    </>
  );
};
